<template>
  <div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="formgrid grid">
        <div class="field col-12">
          <label
            :class="{ 'p-error': v$.form.account_id.$invalid && submitted }"
            >Kode *</label
          >
          <Dropdown
            v-model="form.account_id"
            :filter="true"
            :options="accounts"
            :class="{ 'p-invalid': v$.form.account_id.$invalid && submitted }"
            optionValue="id"
            optionLabel="nama"
            placeholder="Pilih kode"
            class="w-full"
          >
            <template #option="slotProps">
              <div>
                <span>
                  {{ slotProps.option.kode }}&nbsp;{{ slotProps.option.nama }}
                </span>
              </div>
            </template>
          </Dropdown>
          <small
            v-if="
              (v$.form.account_id.$invalid && submitted) ||
              v$.form.account_id.$pending.$response
            "
            class="p-error"
            >{{ v$.form.account_id.required.$message }}</small
          >
        </div>
        <div class="field col-12">
          <label :class="{ 'p-error': v$.form.saldo.$invalid && submitted }"
            >Saldo</label
          >
          <InputNumber
            v-model="form.saldo"
            :class="{ 'p-invalid': v$.form.saldo.$invalid && submitted }"
            class="w-full"
          />
          <small
            v-if="
              (v$.form.saldo.$invalid && submitted) ||
              v$.form.saldo.$pending.$response
            "
            class="p-error"
            >{{ v$.form.saldo.required.$message }}</small
          >
        </div>
      </div>
      <div class="flex justify-content-end align-items-end">
        <Button
          label="Tutup"
          icon="pi pi-times"
          @click="$emit('close')"
          class="p-button-text mr-2"
        />
        <Button
          :loading="loading"
          label="Simpan"
          icon="pi pi-check"
          type="submit"
        />
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { helpers, required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
    accounts: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      submitted: false,
    }
  },
  computed: {
    form() {
      return this.item
    },
  },
  methods: {
    handleSubmit(isFormValid) {
      this.submitted = true
      let form = {
        id: this.form.id,
        account_id: this.form.account_id,
        saldo: this.form.saldo,
      }

      if (!isFormValid) {
        return
      }

      this.$emit('save', form)
    },
  },
  validations() {
    return {
      form: {
        account_id: {
          required: helpers.withMessage('Kode harus diisi.', required),
        },
        saldo: {
          required: helpers.withMessage('Saldo harus diisi.', required),
        },
      },
    }
  },
}
</script>
